import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import { SectionVideoBody, SectionVideoDetails } from "types/api/blocks/sectionVideo";

function useSectionVideoApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionVideo = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionVideoDetails> => {
        return get<PathParamsWithId, undefined, SectionVideoDetails>({
            url: "/blocks/section-video/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionVideo = React.useCallback((body: SectionVideoBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionVideoBody, null>({
            url: "/blocks/section-video",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionVideo = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-video/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionVideo,
        saveSectionVideo,
        deleteSectionVideo
    };
}

export default useSectionVideoApi;